import React, { useEffect } from 'react';
import * as S from './style';
import { BlobInActiveIcon, BlobActiveIcon } from '../image-cdn-urls';
import Image from '../../../components/loggedout/common/Image';
export var BlobWithCircle = function (props) {
    useEffect(function () {
        if (props.blobData.displayAge == props.selectedAge) {
            props.setBlobActive && props.setBlobActive(true);
        }
    }, [props.blobData.displayAge]);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.BlobWrapper, { key: props.index, onClick: function () { return props.blobClickHandler(props.blobData.id, props.index); }, isPdsScreen: props.pdsScreen },
            !props.pdsScreen && props.blobData.circleData && React.createElement(S.CircleIcon, { id: "circle-".concat(props.blobData.id), top: props.blobData.circleData.top, left: props.blobData.circleData.left, diameter: props.blobData.circleData.diameter, circleColor: props.blobData.circleData.color }),
            React.createElement(S.IconTextWrapper, { isPdsScreen: props.pdsScreen, id: "blob-".concat(props.blobData.id) },
                React.createElement(S.BlobIcon, { rotateTimes: props.blobData.rotate, isPdsScreen: props.pdsScreen },
                    React.createElement(Image, { src: props.isBlobActive ? BlobActiveIcon : BlobInActiveIcon, alt: 'blob' })),
                React.createElement(S.AgeText, null,
                    React.createElement(S.AgeNumber, { smallText: props.pdsScreen }, props.blobData.displayAge),
                    React.createElement(S.Text, { smallText: props.pdsScreen }, "years old"))))));
};
export default BlobWithCircle;
